import Enduser from "./enduser";

export default Enduser;